export default "__VITE_ASSET__C2309Vnc__"